// extracted by mini-css-extract-plugin
export default {"container_fluid":"CreateAssessment_container_fluid__VK9GF","col_6":"CreateAssessment_col_6__+IxPd"};